<template>
  <div>
    <b-card id="card-youtube-internal-filters" class="mb-0 w-100">
      <select-network-search
        :networks_avaibles="networks_avaibles"
        :select_network_dad="select_network"
        @update_select_network="updateSelectNetwork"
        class="select-network-search"
      ></select-network-search>

      <b-row class="m-0 p-0 w-100">
        <!-- Ubicación de audiencia -->
        <b-col class="col-12 col-md-6 col-lg filter-outline p-0">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100" ref="filter_audience_location_top">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left align-middle color-gray-light d-block">
                    <span class="search-Map-Pin4"></span> {{ $t('search.audience_location') }}
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold d-block m-0">{{ audienceLocationText }}</p>
              </div>
            </template>
            <b-dropdown-header :key="change_audience_location_yti" class="b-dropdown-header-location-filter-padding">
              <div v-for="(location, index) in audience_locations_yti" :key="index">
                <audience-location-filter
                  :key="change_audience_location_yti + '_top_' + index"
                  :show_remove="index > 0"
                  :index="index"
                  :location="location"
                  :only_countries="true"
                  :main_locations_filter="main_locations_filter"
                  @changeLocationAudienceChild="changeAudienceLocationYti"
                  @removeAudienceLocationChild="removeAudienceLocationYti"
                />
              </div>
              <div v-if="hasSelectedAudienceLocation" class="p-custom">
                <hr/>
                <b-link v-show="audience_locations_yti.length < 3" @click="addAudienceLocationYti()" class="text-blue">{{ $t('search.addLocation') }}</b-link>
                <div v-show="audience_locations_yti.length === 3" class="white-space-wrap small text-muted">{{ $t('search.max3Locations') }}</div>
              </div>
            </b-dropdown-header>
          </b-dropdown>
        </b-col>

        <!-- Edad de audiencia -->
        <b-col class="col-12 col-md-6 col-lg filter-outline p-0">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left color-gray-light d-block">
                    <span class="search-Busy-1"></span> {{ $t('search.audience_age') }}
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold d-block m-0">{{ audienceAgeLabel }}</p>
              </div>
            </template>
            <b-dropdown-header class="p-05 pt-0">
              <div v-for="age_range in age_ranges" :key="age_range.key" class="mb-1">
                <div
                  class="button-gender"
                  :class="{ 'active-option': selected_age_range === age_range.key }"
                  @click="selected_age_range = selected_age_range === age_range.key ? null : age_range.key; getCounter()"
                >
                  {{ age_range.label }}
                </div>
              </div>
              <div v-if="selected_age_range" class="mt-1">
                <div class="avenir-medium mb-1">{{ $t('search.moreOf') || 'Más del' }} <strong>{{ audience_age_percentage }}</strong>% {{ $t('search.ofAudience') || 'de la audiencia' }}</div>
                <component
                  :is="vue_slider"
                  v-model="audience_age_percentage"
                  :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :max="99"
                  :min="1"
                  :interval="1"
                  @drag-end="getCounter"
                  :tooltip="'none'"
                />
              </div>
            </b-dropdown-header>
          </b-dropdown>
        </b-col>

        <!-- Género de audiencia -->
        <b-col class="col-md-6 col-lg filter-outline p-0" cols="12">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left align-middle color-gray-light mb-1 d-block">
                    <span class="search-intersex"></span> {{ $t('search.audience_gender') }}
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold m-0">{{ audienceGenderLabel }}</p>
              </div>
            </template>
            <b-dropdown-header class="p-05 pt-0">
              <div v-for="gender in gender_options" :key="gender.key"
                class="button-gender"
                :class="{ 'active-option': selected_audience_gender === gender.key }"
                @click="selected_audience_gender = selected_audience_gender === gender.key ? null : gender.key; getCounter()"
              >
                {{ gender.label }}
              </div>
              <div v-if="selected_audience_gender" class="mt-1">
                <div class="avenir-medium mb-1">{{ $t('search.moreOf') || 'Más del' }} <strong>{{ audience_gender_percentage }}</strong>% {{ $t('search.ofAudience') || 'de la audiencia' }}</div>
                <component
                  :is="vue_slider"
                  v-model="audience_gender_percentage"
                  :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :max="99"
                  :min="1"
                  :interval="1"
                  @drag-end="getCounter"
                  :tooltip="'none'"
                />
              </div>
            </b-dropdown-header>
          </b-dropdown>
        </b-col>

        <!-- Promedio de views por video -->
        <b-col class="col-md-6 col-lg filter-outline p-0" cols="12">
          <b-dropdown block no-caret class="dropdown-filters" variant="outline-gray-light" menu-class="w-100">
            <template #button-content>
              <div class="d-flex flex-column justify-content-between h-100">
                <b-form-group class="mb-0">
                  <span class="text-left align-middle color-gray-light mb-1 d-block">
                    <b-icon class="search-icon icon-size-14" icon="eye"/><span class="ml-1">{{ $t('search.averageViewsVideo') || 'Promedio vistas/video' }}</span>
                  </span>
                </b-form-group>
                <p class="text-left font-weight-bold m-0">{{ rangeLabel(avg_views_per_video, 200000000) || $t('search.realty.any') }}</p>
              </div>
            </template>
            <b-dropdown-header class="p-05 pt-0">
              <slider-range
                :tooltip="'none'"
                class="mt-1"
                :init_range="avg_views_per_video"
                :interval="1000"
                :max_value="200000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="avg_views_per_video"
                @changeSlide="changeSlideComponent"
                :key="avg_views_per_video[0] + avg_views_per_video[1] + 'tb'"
              />
            </b-dropdown-header>
          </b-dropdown>
        </b-col>

        <!-- Botón todos los filtros -->
        <div class="d-flex align-items-center container-more-filters">
          <b-button
            variant="outline-secondary"
            class="d-flex align-items-center justify-content-center w-100"
            @click="open_sidebar = true"
          >
            <b-icon icon="filter" class="mr-03" />
            {{ $t('search.allFilters') }}
            <b-badge
              v-if="checkFiltersUsed().length > 0"
              pill
              class="ml-1 d-inline-flex align-items-center justify-content-center"
              style="background-color:#0096fe;"
            >{{ checkFiltersUsed().length }}</b-badge>
          </b-button>
        </div>
      </b-row>
    </b-card>

    <!-- Barra de búsqueda YTI -->
    <b-row class="m-0 p-0 yti-search-bar-wrap">
      <b-col class="col-12 col-md p-0">
        <div class="w-100 card-filters-search-by">
          <div class="d-flex w-100 align-items-center h-100 flex-wrap flex-md-nowrap">
            <!-- Selector: Categorías | Palabras clave -->
            <component
              :is="vue_select"
              class="select-filters-searcher-by"
              id="yti-mode-select"
              :options="yti_search_mode_options"
              label="label"
              :reduce="it => it.value"
              v-model="yti_search_mode"
              :clearable="false"
              :searchable="false"
            />
            <!-- Selector Afinidad | Intención (solo en modo Categorías) -->
            <component
              v-if="yti_search_mode === 'categories'"
              :is="vue_select"
              class="select-filters-searcher-by"
              id="yti-interest-type-select"
              :options="interest_type_options"
              label="label"
              :reduce="it => it.value"
              v-model="interest_type"
              :clearable="false"
              :searchable="false"
            />
            <!-- Input condicional -->
            <div class="position-relative w-100 h-100">
              <!-- Modo Categorías: input con dropdown -->
              <b-form-input
                v-if="yti_search_mode === 'categories'"
                class="input-search-by-influencer h-100"
                placeholder="Buscar por categoría..."
                v-model="search_bar_query"
                autocomplete="off"
                @focus="show_search_bar_dropdown = true"
                @blur="onSearchBarBlur"
              />
              <!-- Modo Palabras clave: chip editable o input libre -->
              <template v-else>
                <div v-if="keyword_locked && search_keyword" class="d-flex align-items-center h-100 px-2 keyword-locked-display">
                  <span class="keyword-locked-text">{{ search_keyword }}</span>
                  <span class="keyword-edit-btn ml-1" @click="unlockKeyword" title="Editar búsqueda">
                    <feather-icon icon="Edit2Icon" size="13"/>
                  </span>
                  <span class="keyword-clear-btn ml-1" @click="clearKeyword" title="Quitar búsqueda">
                    <feather-icon icon="XIcon" size="13"/>
                  </span>
                </div>
                <b-form-input
                  v-else
                  ref="keyword_input"
                  class="input-search-by-influencer h-100"
                  placeholder="Buscar por contenido..."
                  v-model="search_keyword"
                  autocomplete="off"
                  @keyup.enter="lockKeywordAndSearch"
                  @blur="onKeywordBlur"
                  @blur.native="onKeywordBlur"
                />
              </template>
              <!-- Dropdown de categorías -->
              <div class="float-suggestions-search" v-if="yti_search_mode === 'categories' && show_search_bar_dropdown">
                <p v-if="searchBarFiltered.length === 0" class="text-muted small m-05">Sin resultados</p>
                <template v-else>
                  <div v-for="(items, letter) in searchBarGrouped" :key="letter" class="mb-2">
                    <strong class="m-06">{{ letter }}</strong>
                    <p v-for="item in items" :key="item" class="avenir-medium m-05">
                      <span
                        @mousedown.prevent="toggleInterest(item)"
                        class="text-category p-05"
                        :class="{ 'yti-cat-active': selected_interest_labels.includes(item) }"
                      >{{ item }}</span>
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <button-submit-filters
        class="mb-1 mb-md-0"
        :class_custom="true"
        :searched="searched"
        :loading="loading"
        :text="getText()"
        :total_results="buttonTotalResults"
        @sendFilters="sendFilters()"
        :key="`change_submit_${loading}`"
      />
    </b-row>

    <apply-filters
      :filters="checkFiltersUsed()"
      @deleteFilter="deleteFilter"
      @updateModel="updateModel"
      @clearAllFilters="clearFilters"
    />

    <!-- Sidebar de filtros avanzados -->
    <b-sidebar
      v-model="open_sidebar"
      backdrop
      shadow
      right
      width="700px"
      body-class="background-white"
      no-header
      footer-class="background-white footer-sidebar-filters"
      class="sidebar-filters-nets"
    >
      <feather-icon
        class="close-component"
        icon="XIcon"
        size="16"
        @click="open_sidebar = false"
      />
      <b-row class="p-2">

        <!-- Columna izquierda: Canal + Métricas privadas -->
        <b-col class="col-12 col-md">
          <h4 class="blueC"><strong>{{ $t('search.influencer') }}</strong></h4>

          <!-- Suscriptores -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('subscriber_count')">
              <span class="search-Users"></span><strong>{{ $t('search.audienceSize') }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_subscriber_count" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_subscriber_count" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_subscriber_count">
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="subscriber_count"
                :interval="1000"
                :max_value="500000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="subscriber_count"
                @changeSlide="changeSlideComponent"
                :key="subscriber_count[0] + subscriber_count[1] + 'sb'"
              />
              <div class="mt-1">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio
                    v-for="(size, index) in subscriber_sizes"
                    :key="index"
                    v-model="subscriber_type_selected"
                    :aria-describedby="ariaDescribedby"
                    :value="size.value"
                    class="mt-1 avenir-medium form-ratio-followers-searcher"
                  >
                    <div class="d-flex justify-content-between w-100">
                      <div>{{ $t(`search.${size.text}`) }}</div>
                      <div>{{ size.value_label }}</div>
                    </div>
                  </b-form-radio>
                </b-form-group>
              </div>
            </div>
          </div>

          <!-- Vistas totales -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('view_count')">
              <strong><b-icon class="search-icon" icon="eye"/>{{ $t('youtube.views') || 'Vistas totales' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_view_count" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_view_count" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_view_count">
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="view_count"
                :interval="10000"
                :max_value="200000000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="view_count"
                @changeSlide="changeSlideComponent"
                :key="view_count[0] + view_count[1]"
              />
            </div>
          </div>

          <!-- Cantidad de videos -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('video_count')">
              <strong><b-icon class="search-icon" icon="camera-video"/>{{ $t('youtube.videoCount') || 'Cantidad de videos' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_video_count" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_video_count" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_video_count">
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="video_count"
                :interval="10"
                :max_value="100000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="video_count"
                @changeSlide="changeSlideComponent"
                :key="video_count[0] + video_count[1]"
              />
            </div>
          </div>

          <!-- País del canal -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('region_code')">
              <span class="search-Map-Pin4"></span><strong>{{ $t('search.influencerLocation') }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_region_code" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_region_code" />
            </span>
            <div class="d-none" ref="collapse_filters_region_code">
              <div v-for="(location, index) in channel_locations_yti" :key="index">
                <audience-location-filter
                  :key="change_channel_location_yti + '_sb_' + index"
                  :show_remove="index > 0"
                  :show_slider="false"
                  :index="index"
                  :location="location"
                  :only_countries="true"
                  :main_locations_filter="main_locations_filter"
                  @changeLocationAudienceChild="changeChannelLocationYti"
                  @removeAudienceLocationChild="removeChannelLocationYti"
                />
              </div>
              <div v-if="hasSelectedChannelLocation" class="px-1 pb-1">
                <hr class="my-05"/>
                <b-link v-show="channel_locations_yti.length < 3" @click="addChannelLocationYti()" class="text-blue">{{ $t('search.addLocation') }}</b-link>
                <div v-show="channel_locations_yti.length === 3" class="white-space-wrap small text-muted">{{ $t('search.max3Locations') }}</div>
              </div>
            </div>
          </div>

          <!-- Categorías temáticas -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('topic_categories')">
              <strong><b-icon class="search-icon" icon="tags"/>{{ $t('search.categories') || 'Categorías temáticas' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_topic_categories" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_topic_categories" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_topic_categories">
              <b-form-input
                v-model="topic_query"
                :placeholder="$t('search.typeCategory') || 'Escribe una categoría'"
                size="sm"
                class="mb-1"
                @input="filterTopics"
              />
              <div style="max-height: 160px; overflow-y: auto;">
                <b-form-checkbox
                  v-for="topic in filtered_topics"
                  :key="topic.value"
                  v-model="selected_topic_categories"
                  :value="topic.value"
                  class="mb-05"
                  @change="getCounter"
                >
                  {{ topic.label }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <h4 class="blueC mt-2"><strong>{{ $t('search.performance') }}</strong></h4>

          <!-- Promedio likes por video -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('avg_likes_per_video')">
              <strong><b-icon class="search-icon" icon="hand-thumbs-up"/>{{ $t('youtube.avgLikes') || 'Promedio likes por video' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_avg_likes_per_video" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_avg_likes_per_video" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_avg_likes_per_video">
              <div class="content-type-mini">
                <span class="small text-muted d-block mb-05">{{ $t('search.contentType') || 'Tipo de contenido' }}:</span>
                <div class="d-flex" style="gap:4px; flex-wrap:wrap;">
                  <span v-for="ct in content_type_options" :key="ct.value"
                    class="content-type-pill" :class="{ active: content_type === ct.value }"
                    @click="content_type = ct.value; getCounter()"
                  >{{ ct.label }}</span>
                </div>
              </div>
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="avg_likes_per_video"
                :interval="100"
                :max_value="5000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="avg_likes_per_video"
                @changeSlide="changeSlideComponent"
                :key="avg_likes_per_video[0] + avg_likes_per_video[1]"
              />
            </div>
          </div>

          <!-- Promedio comentarios por video -->
          <div class="py-2">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('avg_comments_per_video')">
              <strong><b-icon class="search-icon" icon="chat-text"/>{{ $t('youtube.avgComments') || 'Promedio comentarios' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_avg_comments_per_video" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_avg_comments_per_video" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_avg_comments_per_video">
              <div class="content-type-mini">
                <span class="small text-muted d-block mb-05">{{ $t('search.contentType') || 'Tipo de contenido' }}:</span>
                <div class="d-flex" style="gap:4px; flex-wrap:wrap;">
                  <span v-for="ct in content_type_options" :key="ct.value"
                    class="content-type-pill" :class="{ active: content_type === ct.value }"
                    @click="content_type = ct.value; getCounter()"
                  >{{ ct.label }}</span>
                </div>
              </div>
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="avg_comments_per_video"
                :interval="10"
                :max_value="1000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="avg_comments_per_video"
                @changeSlide="changeSlideComponent"
                :key="avg_comments_per_video[0] + avg_comments_per_video[1]"
              />
            </div>
          </div>
        </b-col>

        <!-- Columna derecha: Audiencia -->
        <b-col class="col-12 col-md">
          <h4 class="blueC"><strong>{{ $t('search.audienceFilters') || 'Audiencia' }}</strong></h4>

          <!-- Alcance único -->
          <div class="py-2 border-bottom">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('unique_reach')">
              <strong><b-icon class="search-icon" icon="broadcast"/>{{ $t('youtube.uniqueReach') || 'Alcance único' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_unique_reach" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_unique_reach" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_unique_reach">
              <div class="content-type-mini">
                <span class="small text-muted d-block mb-05">{{ $t('search.contentType') || 'Tipo de contenido' }}:</span>
                <div class="d-flex" style="gap:4px; flex-wrap:wrap;">
                  <span v-for="ct in content_type_options" :key="ct.value"
                    class="content-type-pill" :class="{ active: content_type === ct.value }"
                    @click="content_type = ct.value; getCounter()"
                  >{{ ct.label }}</span>
                </div>
              </div>
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="unique_reach"
                :interval="10000"
                :max_value="500000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="unique_reach"
                @changeSlide="changeSlideComponent"
                :key="unique_reach[0] + unique_reach[1]"
              />
            </div>
          </div>

          <!-- Espectadores únicos -->
          <div class="py-2">
            <span class="toggle-collapse-filters cursor-pointer" @click="toggleCollapse('unique_viewers')">
              <strong><b-icon class="search-icon" icon="people"/>{{ $t('youtube.uniqueViewers') || 'Espectadores únicos' }}</strong>
              <feather-icon class="chev-more-filters" icon="ChevronDownIcon" ref="chev_down_unique_viewers" />
              <feather-icon class="chev-more-filters d-none" icon="ChevronUpIcon" ref="chev_up_unique_viewers" />
            </span>
            <div class="d-none mt-1" ref="collapse_filters_unique_viewers">
              <div class="content-type-mini">
                <span class="small text-muted d-block mb-05">{{ $t('search.contentType') || 'Tipo de contenido' }}:</span>
                <div class="d-flex" style="gap:4px; flex-wrap:wrap;">
                  <span v-for="ct in content_type_options" :key="ct.value"
                    class="content-type-pill" :class="{ active: content_type === ct.value }"
                    @click="content_type = ct.value; getCounter()"
                  >{{ ct.label }}</span>
                </div>
              </div>
              <slider-range
                :tooltip="'none'"
                class="mt-3"
                :init_range="unique_viewers"
                :interval="10000"
                :max_value="500000000"
                :min_value="0"
                :any_text="$t('search.realty.any')"
                :no_max_limit="true"
                identifier="unique_viewers"
                @changeSlide="changeSlideComponent"
                :key="unique_viewers[0] + unique_viewers[1]"
              />
            </div>
          </div>
        </b-col>
      </b-row>

      <template #footer>
        <button-submit-filters
          class="m-1"
          :searched="searched"
          :loading="loading"
          :text="getText()"
          :total_results="buttonTotalResults"
          @sendFilters="sendFilters()"
          @closeSideBar="open_sidebar = false"
        />
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import service from '@/services/search'
import { getFormat } from '@/libs/utils/formats'
import {
  BCard, BRow, BCol, BBadge, BButton, BDropdown, BDropdownHeader, BDropdownItem,
  BFormGroup, BFormInput, BFormCheckbox, BFormRadio, BLink, BSidebar,
} from 'bootstrap-vue'

const COUNTRIES = [
  { code: 'MX', name: 'México' }, { code: 'US', name: 'Estados Unidos' },
  { code: 'CO', name: 'Colombia' }, { code: 'AR', name: 'Argentina' },
  { code: 'ES', name: 'España' }, { code: 'CL', name: 'Chile' },
  { code: 'PE', name: 'Perú' }, { code: 'VE', name: 'Venezuela' },
  { code: 'EC', name: 'Ecuador' }, { code: 'GT', name: 'Guatemala' },
  { code: 'CU', name: 'Cuba' }, { code: 'BO', name: 'Bolivia' },
  { code: 'DO', name: 'República Dominicana' }, { code: 'HN', name: 'Honduras' },
  { code: 'PY', name: 'Paraguay' }, { code: 'SV', name: 'El Salvador' },
  { code: 'NI', name: 'Nicaragua' }, { code: 'CR', name: 'Costa Rica' },
  { code: 'PA', name: 'Panamá' }, { code: 'UY', name: 'Uruguay' },
  { code: 'BR', name: 'Brasil' }, { code: 'PT', name: 'Portugal' },
  { code: 'GB', name: 'Reino Unido' }, { code: 'CA', name: 'Canadá' },
  { code: 'DE', name: 'Alemania' }, { code: 'FR', name: 'Francia' },
  { code: 'IT', name: 'Italia' }, { code: 'IN', name: 'India' },
  { code: 'JP', name: 'Japón' }, { code: 'KR', name: 'Corea del Sur' },
  { code: 'AU', name: 'Australia' }, { code: 'ZA', name: 'Sudáfrica' },
]

const COUNTRY_NAME_TO_CODE = {}
COUNTRIES.forEach(c => { COUNTRY_NAME_TO_CODE[c.name.toLowerCase()] = c.code })


export default {
  name: 'filtroYoutubeInternal',
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    BDropdown,
    BDropdownHeader,
    BDropdownItem,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormRadio,
    BLink,
    BSidebar,
    selectNetworkSearch: () => import('./filters/components/selectNetworkSearch.vue'),
    buttonSubmitFilters: () => import('./buttonSubmitFilters.vue'),
    sliderRange: () => import('./sliderRange.vue'),
    applyFilters: () => import('./filters/applyFilters.vue'),
    AudienceLocationFilter: () => import('@/views/buscador/filters/audience_locations.vue'),
  },
  props: {
    networks_avaibles: { type: Array, default: () => [] },
    select_network: { type: Object, default: () => ({}) },
    initial_filters: { type: Object, default: () => ({}) },
    filters_history: { type: Object, default: () => ({}) },
    main_locations_filter: { type: Array, default: () => [] },
  },
  data() {
    return {
      getFormat,
      vue_slider: null,
      vue_select: null,
      open_sidebar: false,
      loading: false,
      searched: false,
      total_results: 0,
      search_bar_query: '',
      show_search_bar_dropdown: false,
      yti_search_mode: 'categories',
      yti_search_mode_options: [
        { label: 'Intereses', value: 'categories' },
        { label: 'Palabras clave', value: 'keywords' },
      ],
      search_keyword: '',
      keyword_locked: false,

      subscriber_type_selected: null,
      subscriber_sizes: [
        { value: [1000, 10000], text: 'nano', value_label: '(1K-10K)' },
        { value: [10000, 50000], text: 'micro', value_label: '(10K-50K)' },
        { value: [50000, 500000], text: 'levelMedium', value_label: '(50K-500K)' },
        { value: [500000, 1000000], text: 'macro', value_label: '(500K-1M)' },
        { value: [1000000, null], text: 'mega', value_label: '(1M+)' },
      ],

      // Channel filters
      subscriber_count: [0, 500000000],
      view_count: [0, 200000000000],
      video_count: [0, 100000],
      channel_locations_yti: [{}],
      change_channel_location_yti: false,
      selected_topic_categories: [],
      topic_query: '',
      all_topics: [],
      filtered_topics: [],
      // Content type
      content_type: 'OVERALL',
      content_type_options: [
        { value: 'OVERALL', label: 'Overall' },
        { value: 'SHORTS', label: 'Shorts' },
        { value: 'VOD', label: 'Videos (VOD)' },
      ],

      // Private metrics
      avg_views_per_video: [0, 200000000],
      avg_likes_per_video: [0, 5000000],
      avg_comments_per_video: [0, 1000000],
      avg_reach_per_video: [0, 200000000],
      unique_viewers: [0, 500000000],
      unique_reach: [0, 500000000],

      // Audience age
      selected_age_range: null,
      audience_age_percentage: 20,
      age_ranges: [
        { key: 'age_18_to_24', label: '18 – 24 años' },
        { key: 'age_25_to_34', label: '25 – 34 años' },
        { key: 'age_35_to_44', label: '35 – 44 años' },
        { key: 'age_45_to_54', label: '45 – 54 años' },
        { key: 'age_55_to_64', label: '55 – 64 años' },
        { key: 'age_65_plus', label: '65+ años' },
      ],

      // Audience gender
      selected_audience_gender: null,
      audience_gender_percentage: 55,
      gender_options: [
        { key: 'female', label: 'Femenina' },
        { key: 'male', label: 'Masculina' },
      ],

      // Audience country
      audience_locations_yti: [{}],
      change_audience_location_yti: false,
      audience_country_percentage: 40,

      // Audience interests
      interest_type: 'AFFINITY',
      interest_type_options: [
        { value: 'AFFINITY', label: 'Afinidad' },
        { value: 'IN_MARKET', label: 'Intención de compra' },
      ],
      selected_interest_labels: [],
      interest_query: '',
      all_interests: [],
      filtered_interests: [],
      interest_audience_share: 30,
      show_interest_dropdown: false,

      filters: [
        {
          filter: 'subscriber_count',
          text: this.$t('search.audienceSize'),
          models: [{ name: 'subscriber_count', value: null, default: [0, 500000000] }],
          value: null,
        },
        {
          filter: 'view_count',
          text: 'Vistas totales',
          models: [{ name: 'view_count', value: null, default: [0, 200000000000] }],
          value: null,
        },
        {
          filter: 'video_count',
          text: 'Cantidad de videos',
          models: [{ name: 'video_count', value: null, default: [0, 100000] }],
          value: null,
        },
        {
          filter: 'region_code',
          text: this.$t('search.influencerLocation'),
          models: [{ name: 'channel_locations_yti', value: null, default: [{}] }],
          value: null,
        },
        {
          filter: 'topic_categories',
          text: 'Categorías temáticas',
          models: [{ name: 'selected_topic_categories', value: null, default: [] }],
          value: null,
        },
        {
          filter: 'content_type',
          text: 'Tipo de contenido',
          models: [{ name: 'content_type', value: null, default: 'OVERALL' }],
          value: null,
        },
        {
          filter: 'avg_views_per_video',
          text: this.$t('search.averageViewsVideo') || 'Promedio vistas/video',
          models: [{ name: 'avg_views_per_video', value: null, default: [0, 200000000] }],
          value: null,
        },
        {
          filter: 'avg_likes_per_video',
          text: 'Promedio likes/video',
          models: [{ name: 'avg_likes_per_video', value: null, default: [0, 5000000] }],
          value: null,
        },
        {
          filter: 'avg_comments_per_video',
          text: 'Promedio comentarios/video',
          models: [{ name: 'avg_comments_per_video', value: null, default: [0, 1000000] }],
          value: null,
        },
        {
          filter: 'unique_reach',
          text: 'Alcance único',
          models: [{ name: 'unique_reach', value: null, default: [0, 500000000] }],
          value: null,
        },
        {
          filter: 'unique_viewers',
          text: 'Espectadores únicos',
          models: [{ name: 'unique_viewers', value: null, default: [0, 500000000] }],
          value: null,
        },
        {
          filter: 'audience_country',
          text: this.$t('search.audience_location'),
          models: [
            { name: 'audience_locations_yti', value: null, default: [{}] },
            { name: 'audience_country_percentage', value: null, default: 40 },
          ],
          value: null,
        },
        {
          filter: 'audience_age',
          text: this.$t('search.audience_age'),
          models: [
            { name: 'selected_age_range', value: null, default: null },
            { name: 'audience_age_percentage', value: null, default: 20 },
          ],
          value: null,
        },
        {
          filter: 'audience_gender',
          text: this.$t('search.audience_gender'),
          models: [
            { name: 'selected_audience_gender', value: null, default: null },
            { name: 'audience_gender_percentage', value: null, default: 55 },
          ],
          value: null,
        },
        {
          filter: 'audience_interests',
          text: 'Intereses de audiencia',
          models: [
            { name: 'selected_interest_labels', value: null, default: [] },
            { name: 'interest_type', value: null, default: 'AFFINITY' },
          ],
          value: null,
          multiple_values: true,
          syntax: [],
        },
        {
          filter: 'keyword',
          text: 'Palabra clave',
          models: [
            { name: 'search_keyword', value: null, default: '' },
            { name: 'yti_search_mode', value: null, default: 'categories' },
          ],
          value: null,
        },
      ],
    }
  },
  created() {
    this._settingFromType = false
  },
  async mounted() {
    this.vue_slider = (await import('vue-slider-component')).default
    this.vue_select = (await import('vue-select')).default
    this.fetchTopicCategories()
    this.fetchInterestLabels(this.interest_type)
    setTimeout(() => {
      if (Object.keys(this.filters_history).length === 0) {
        this.getCounter()
      }
    }, 200)
  },
  computed: {
    hasSelectedAudienceLocation() {
      return this.audience_locations_yti.some(loc => loc.id)
    },
    audienceLocationText() {
      const names = this.audience_locations_yti
        .filter(loc => loc.id && loc.name)
        .map(loc => (loc.percentage ? `${loc.name}, ≥${loc.percentage}%` : loc.name))
      return names.length > 0 ? names.join(', ') : this.$t('search.realty.any')
    },
    audienceAgeLabel() {
      if (!this.selected_age_range) return this.$t('search.realty.any')
      const found = this.age_ranges.find(r => r.key === this.selected_age_range)
      if (!found) return this.$t('search.realty.any')
      return `${found.label}, ≥${this.audience_age_percentage}%`
    },
    audienceGenderLabel() {
      if (!this.selected_audience_gender) return this.$t('search.realty.any')
      const found = this.gender_options.find(g => g.key === this.selected_audience_gender)
      if (!found) return this.$t('search.realty.any')
      return `${found.label}, ≥${this.audience_gender_percentage}%`
    },
    hasSelectedChannelLocation() {
      return this.channel_locations_yti.some(loc => loc.id)
    },
    channelLocationText() {
      const names = this.channel_locations_yti
        .filter(loc => loc.id && loc.name)
        .map(loc => loc.name)
      return names.length > 0 ? names.join(', ') : this.$t('search.realty.any')
    },
    buttonTotalResults() {
      if (this.yti_search_mode === 'keywords') return Math.max(1, this.total_results)
      return this.total_results
    },
    searchBarFiltered() {
      const q = this.search_bar_query.toLowerCase()
      if (!q) return this.all_interests
      return this.all_interests.filter(i => i.toLowerCase().includes(q))
    },
    searchBarGrouped() {
      return this.searchBarFiltered.reduce((acc, item) => {
        const letter = item[0].toUpperCase()
        if (!acc[letter]) acc[letter] = []
        acc[letter].push(item)
        return acc
      }, {})
    },
  },
  methods: {
    updateSelectNetwork(val) {
      this.$emit('update_select_network', val)
    },
    getText() {
      if (this.loading) return this.$t('search.searching') || 'Buscando...'
      if (this.yti_search_mode === 'keywords' && !this.search_keyword) return this.$t('search.buttonSearch') || 'Buscar'
      return this.$t('search.showResults', { count: getFormat(this.total_results) })
    },
    getSubscribersLabel() {
      const [from, to] = this.subscriber_count
      if (from === 0 && to === 500000000) return this.$t('search.realty.any')
      if (to === 500000000) return `${getFormat(from)}+`
      return `${getFormat(from)} – ${getFormat(to)}`
    },
    getChannelCountryCodes() {
      return this.channel_locations_yti
        .filter(loc => loc.id && loc.name)
        .map(loc => COUNTRY_NAME_TO_CODE[loc.name.toLowerCase()] || null)
        .filter(Boolean)
    },
    changeChannelLocationYti({ location, percentage, key }) {
      this.$set(this.channel_locations_yti, key, { ...location, percentage })
      this.getCounter()
    },
    removeChannelLocationYti(location, index, force_remove = false) {
      if (force_remove) {
        this.channel_locations_yti.splice(index, 1)
      } else {
        this.$set(this.channel_locations_yti, index, {})
      }
      if (this.channel_locations_yti.length === 0) {
        this.channel_locations_yti = [{}]
      }
      this.change_channel_location_yti = !this.change_channel_location_yti
      this.getCounter()
    },
    addChannelLocationYti() {
      this.channel_locations_yti.push({})
      this.change_channel_location_yti = !this.change_channel_location_yti
    },
    getAudienceCountryCodes() {
      return this.audience_locations_yti
        .filter(loc => loc.id && loc.name)
        .map(loc => COUNTRY_NAME_TO_CODE[loc.name.toLowerCase()] || null)
        .filter(Boolean)
    },
    changeAudienceLocationYti({ location, percentage, key }) {
      this.$set(this.audience_locations_yti, key, { ...location, percentage })
      this.audience_country_percentage = percentage
      this.getCounter()
    },
    removeAudienceLocationYti(location, index, force_remove = false) {
      if (force_remove) {
        this.audience_locations_yti.splice(index, 1)
      } else {
        this.$set(this.audience_locations_yti, index, {})
      }
      if (this.audience_locations_yti.length === 0) {
        this.audience_locations_yti = [{}]
      }
      this.getCounter()
    },
    addAudienceLocationYti() {
      this.audience_locations_yti.push({})
      this.change_audience_location_yti = !this.change_audience_location_yti
    },
    filterTopics() {
      const q = this.topic_query.toLowerCase()
      this.filtered_topics = this.all_topics.filter(t => t.label.toLowerCase().includes(q))
    },
    filterInterests() {
      const q = this.interest_query.toLowerCase()
      this.filtered_interests = this.all_interests.filter(i => i.toLowerCase().includes(q))
    },
    onInterestBlur() {
      setTimeout(() => { this.show_interest_dropdown = false }, 200)
    },
    onSearchBarBlur() {
      setTimeout(() => { this.show_search_bar_dropdown = false }, 200)
    },
    onKeywordBlur() {
      if (this.search_keyword) {
        this.keyword_locked = true
        this.getCounter()
      }
    },
    lockKeywordAndSearch() {
      if (this.search_keyword) this.keyword_locked = true
      this.sendFilters()
    },
    unlockKeyword() {
      this.keyword_locked = false
      this.$nextTick(() => {
        const input = this.$refs.keyword_input
        if (input && input.$el) input.$el.focus()
        else if (input) input.focus()
      })
    },
    clearKeyword() {
      this.search_keyword = ''
      this.keyword_locked = false
      this.getCounter()
    },
    onInterestTypeClick(type) {
      this.interest_type = type
      this.selected_interest_labels = []
      this.interest_query = ''
      this.search_bar_query = ''
    },
    toggleInterest(interest) {
      const idx = this.selected_interest_labels.indexOf(interest)
      if (idx > -1) {
        this.selected_interest_labels.splice(idx, 1)
      } else {
        this.selected_interest_labels.push(interest)
      }
      this.getCounter()
    },
    removeInterest(label) {
      const idx = this.selected_interest_labels.indexOf(label)
      if (idx > -1) this.selected_interest_labels.splice(idx, 1)
      this.getCounter()
    },
    setInterestLabels(labels) {
      this.selected_interest_labels = [...labels]
      this.getCounter()
    },
    async fetchTopicCategories() {
      const data = await service.getYouTubeTopicCategories()
      if (Array.isArray(data) && data.length > 0) {
        this.all_topics = data.map(item => ({
          value: item.url || item.value || item,
          label: item.name || item.label || (item.url ? item.url.split('/').pop().replace(/_/g, ' ') : item),
        }))
        this.filtered_topics = [...this.all_topics]
      }
    },
    async fetchInterestLabels(interest_type) {
      if (!interest_type) {
        this.all_interests = []
        this.filtered_interests = []
        return
      }
      const data = await service.getYouTubeInterestLabels(interest_type)
      if (Array.isArray(data)) {
        this.all_interests = data.map(item => item.label || item.name || item)
        this.filtered_interests = [...this.all_interests]
      } else {
        this.all_interests = []
        this.filtered_interests = []
      }
    },
    toggleCollapse(id) {
      const el = this.$refs[`collapse_filters_${id}`]
      const chevDown = this.$refs[`chev_down_${id}`]
      const chevUp = this.$refs[`chev_up_${id}`]
      if (!el) return
      const isHidden = el.classList.contains('d-none')
      if (isHidden) {
        el.classList.remove('d-none')
        chevDown && chevDown.classList.add('d-none')
        chevUp && chevUp.classList.remove('d-none')
      } else {
        el.classList.add('d-none')
        chevDown && chevDown.classList.remove('d-none')
        chevUp && chevUp.classList.add('d-none')
      }
    },
    closeCollapse(id) {
      const el = this.$refs[`collapse_filters_${id}`]
      if (!el) return
      el.classList.add('d-none')
      const chevUp = this.$refs[`chev_up_${id}`]
      const chevDown = this.$refs[`chev_down_${id}`]
      if (chevUp) chevUp.classList.add('d-none')
      if (chevDown) chevDown.classList.remove('d-none')
    },
    changeSlideComponent(identifier, value) {
      this[identifier] = value
      this.getCounter()
    },
    checkFiltersUsed() {
      return this.filters.filter(f => f.models[0].value !== null)
    },
    deleteFilter(name) {
      const f = this.filters.find(i => i.filter === name)
      if (!f) return
      f.models.forEach(m => { this[m.name] = m.default })
      if (name === 'keyword') {
        this.keyword_locked = false
        this.loading = false
      }
      f.value = null
      this.closeCollapse(f.filter)
      this.getCounter()
      this.searched = true
    },
    updateModel(data) {
      if (data.name_emit) this[data.name_emit](...data.params)
    },
    clearFilters(loading_results = true, send_service = true) {
      this.filters.forEach(f => this.deleteFilter(f.filter))
      if (send_service) {
        this.sendFilters(loading_results)
        this.getCounter()
      }
    },
    addKeywordFilter() {},
    getFilters() {
      const nullIfDefault = (val, def) => (JSON.stringify(val) === JSON.stringify(def) ? null : val)

      const subChanged = nullIfDefault(this.subscriber_count, [0, 500000000])
      const vcChanged = nullIfDefault(this.view_count, [0, 200000000000])
      const vidChanged = nullIfDefault(this.video_count, [0, 100000])
      const avpvChanged = nullIfDefault(this.avg_views_per_video, [0, 200000000])
      const alpvChanged = nullIfDefault(this.avg_likes_per_video, [0, 5000000])
      const acpvChanged = nullIfDefault(this.avg_comments_per_video, [0, 1000000])

      const avpvMin = avpvChanged && this.avg_views_per_video[0] > 0 ? this.avg_views_per_video[0] : null
      const avpvMax = avpvChanged && this.avg_views_per_video[1] < 200000000 ? this.avg_views_per_video[1] : null
      const alpvMin = alpvChanged && this.avg_likes_per_video[0] > 0 ? this.avg_likes_per_video[0] : null
      const acpvMin = acpvChanged && this.avg_comments_per_video[0] > 0 ? this.avg_comments_per_video[0] : null
      const uniqueReachMin = nullIfDefault(this.unique_reach, [0, 500000000]) && this.unique_reach[0] > 0 ? this.unique_reach[0] : null
      const uniqueViewersMin = nullIfDefault(this.unique_viewers, [0, 500000000]) && this.unique_viewers[0] > 0 ? this.unique_viewers[0] : null
      const hasMetricFilter = !!(avpvMin || avpvMax || alpvMin || acpvMin || uniqueReachMin || uniqueViewersMin
        || this.selected_age_range || this.selected_audience_gender)

      const f = {
        st: 'yti',
        q: this.yti_search_mode === 'keywords' && this.search_keyword ? this.search_keyword : null,
        subscriber_count_min: subChanged && this.subscriber_count[0] > 0 ? this.subscriber_count[0] : null,
        subscriber_count_max: subChanged && this.subscriber_count[1] < 500000000 ? this.subscriber_count[1] : null,
        view_count_min: vcChanged && this.view_count[0] > 0 ? this.view_count[0] : null,
        view_count_max: vcChanged && this.view_count[1] < 200000000000 ? this.view_count[1] : null,
        video_count_min: vidChanged && this.video_count[0] > 0 ? this.video_count[0] : null,
        video_count_max: vidChanged && this.video_count[1] < 100000 ? this.video_count[1] : null,
        region_code: this.getChannelCountryCodes().length > 0 ? this.getChannelCountryCodes() : null,
        topic_categories: this.selected_topic_categories.length > 0 ? this.selected_topic_categories : null,
        content_type: hasMetricFilter ? this.content_type : null,
        avg_views_per_video_min: avpvMin,
        avg_views_per_video_max: avpvMax,
        avg_likes_per_video_min: alpvMin,
        avg_comments_per_video_min: acpvMin,
        unique_reach_min: uniqueReachMin,
        unique_viewers_min: uniqueViewersMin,
        audience_country: this.getAudienceCountryCodes().length > 0 ? this.getAudienceCountryCodes() : null,
        audience_country_pct_min: this.getAudienceCountryCodes().length > 0 ? this.audience_country_percentage / 100 : null,
        interest_type: this.selected_interest_labels.length > 0 ? this.interest_type : null,
        interest_labels: this.selected_interest_labels.length > 0 ? this.selected_interest_labels : null,
        interest_audience_share_min: this.selected_interest_labels.length > 0 ? this.interest_audience_share / 100 : null,
      }

      if (this.selected_age_range) {
        f[`${this.selected_age_range}_min`] = this.audience_age_percentage / 100
      }
      if (this.selected_audience_gender) {
        f[`gender_${this.selected_audience_gender}_min`] = this.audience_gender_percentage / 100
      }

      const result = {}
      Object.keys(f).forEach(k => { if (f[k] !== null) result[k] = f[k] })
      return result
    },
    rangeLabel(range, max, fmt = v => getFormat(v), suffix = '') {
      const [from, to] = range
      if (from === 0 && to === max) return null
      if (to === max) return `${fmt(from)}${suffix}+`
      if (from === 0) return `Hasta ${fmt(to)}${suffix}`
      return `${fmt(from)}${suffix} – ${fmt(to)}${suffix}`
    },
    syncFiltersValues() {
      const sub = this.subscriber_count
      const subLabel = this.rangeLabel(sub, 500000000)
      this.filters.find(i => i.filter === 'subscriber_count').models[0].value = subLabel
      this.filters.find(i => i.filter === 'subscriber_count').value = subLabel

      const channelNames = this.channel_locations_yti.filter(loc => loc.id && loc.name).map(loc => loc.name)
      this.filters.find(i => i.filter === 'region_code').models[0].value = channelNames.length > 0 ? channelNames.join(', ') : null
      this.filters.find(i => i.filter === 'region_code').value = this.filters.find(i => i.filter === 'region_code').models[0].value

      const ctValue = this.content_type && this.content_type !== 'OVERALL' ? this.content_type : null
      this.filters.find(i => i.filter === 'content_type').models[0].value = ctValue
      this.filters.find(i => i.filter === 'content_type').value = ctValue

      const audienceLocDisplay = this.audience_locations_yti
        .filter(loc => loc.id && loc.name)
        .map(loc => (loc.percentage ? `${loc.name}, ≥${loc.percentage}%` : loc.name))
        .join(', ')
      this.filters.find(i => i.filter === 'audience_country').models[0].value = audienceLocDisplay || null
      this.filters.find(i => i.filter === 'audience_country').value = audienceLocDisplay || null

      const ageFound = this.age_ranges.find(r => r.key === this.selected_age_range)
      const ageLabel = this.selected_age_range ? (ageFound ? `${ageFound.label}, ≥${this.audience_age_percentage}%` : this.selected_age_range) : null
      this.filters.find(i => i.filter === 'audience_age').models[0].value = ageLabel
      this.filters.find(i => i.filter === 'audience_age').value = ageLabel

      const genderFound = this.gender_options.find(g => g.key === this.selected_audience_gender)
      const genderLabel = this.selected_audience_gender ? (genderFound ? `${genderFound.label}, ≥${this.audience_gender_percentage}%` : this.selected_audience_gender) : null
      this.filters.find(i => i.filter === 'audience_gender').models[0].value = genderLabel
      this.filters.find(i => i.filter === 'audience_gender').value = genderLabel

      this.filters.find(i => i.filter === 'audience_interests').models[0].value = this.selected_interest_labels.length > 0 ? this.selected_interest_labels : null
      this.filters.find(i => i.filter === 'audience_interests').value = this.filters.find(i => i.filter === 'audience_interests').models[0].value

      const kwValue = this.yti_search_mode === 'keywords' && this.search_keyword ? this.search_keyword : null
      this.filters.find(i => i.filter === 'keyword').models[0].value = kwValue
      this.filters.find(i => i.filter === 'keyword').value = kwValue

      const avpv = this.avg_views_per_video
      const avpvLabel = this.rangeLabel(avpv, 200000000)
      this.filters.find(i => i.filter === 'avg_views_per_video').models[0].value = avpvLabel
      this.filters.find(i => i.filter === 'avg_views_per_video').value = avpvLabel

      const vc = this.view_count
      const vcLabel = this.rangeLabel(vc, 200000000000)
      this.filters.find(i => i.filter === 'view_count').models[0].value = vcLabel
      this.filters.find(i => i.filter === 'view_count').value = vcLabel

      const topicLabels = this.selected_topic_categories
        .map(val => { const t = this.all_topics.find(x => x.value === val); return t ? t.label : val })
        .join(', ')
      this.filters.find(i => i.filter === 'topic_categories').models[0].value = topicLabels || null
      this.filters.find(i => i.filter === 'topic_categories').value = topicLabels || null

      const vcntLabel = this.rangeLabel(this.video_count, 100000)
      this.filters.find(i => i.filter === 'video_count').models[0].value = vcntLabel
      this.filters.find(i => i.filter === 'video_count').value = vcntLabel

      const alpvLabel = this.rangeLabel(this.avg_likes_per_video, 5000000)
      this.filters.find(i => i.filter === 'avg_likes_per_video').models[0].value = alpvLabel
      this.filters.find(i => i.filter === 'avg_likes_per_video').value = alpvLabel

      const acpvLabel = this.rangeLabel(this.avg_comments_per_video, 1000000)
      this.filters.find(i => i.filter === 'avg_comments_per_video').models[0].value = acpvLabel
      this.filters.find(i => i.filter === 'avg_comments_per_video').value = acpvLabel

      const urLabel = this.rangeLabel(this.unique_reach, 500000000)
      this.filters.find(i => i.filter === 'unique_reach').models[0].value = urLabel
      this.filters.find(i => i.filter === 'unique_reach').value = urLabel

      const uvLabel = this.rangeLabel(this.unique_viewers, 500000000)
      this.filters.find(i => i.filter === 'unique_viewers').models[0].value = uvLabel
      this.filters.find(i => i.filter === 'unique_viewers').value = uvLabel
    },
    updateTotalResults(count) {
      this.total_results = count
      this.loading = false
    },
    getCounter() {
      this.searched = false
      this.syncFiltersValues()
      const rawFilters = this.getFilters()
      delete rawFilters.st
      rawFilters.counter = 1

      this.loading = true
      this.total_results = 0

      service.getResultsYouTubeInternal(rawFilters)
        .then(res => {
          this.total_results = res?.response?.total ?? res?.response?.count ?? 0
          this.loading = false
        })
        .catch(() => { this.loading = false })
    },
    sendFilters(loading_results = true) {
      this.searched = true
      if (this.yti_search_mode === 'keywords') this.loading = true
      this.syncFiltersValues()
      const finalFilters = this.getFilters()
      this.$emit('callYoutubeInternal', finalFilters, loading_results)
      this.$emit('clean_selected')
    },
  },
  watch: {
    search_keyword(val) {
      if (!val) this.keyword_locked = false
    },
    interest_type(val) {
      this.fetchInterestLabels(val)
    },
    subscriber_type_selected(val) {
      if (!val) return
      this._settingFromType = true
      const max = val[1] === null ? 500000000 : val[1]
      this.subscriber_count = [val[0], max]
      this.getCounter()
      this.$nextTick(() => { this._settingFromType = false })
    },
    subscriber_count() {
      if (this._settingFromType) return
      this.subscriber_type_selected = null
    },
  },
}
</script>

<style scoped>
.active-option {
  background-color: #0096fe !important;
  color: #fff !important;
}
.content-type-hint {
  font-size: 0.78rem;
  color: #6c757d;
  line-height: 1.3;
  padding: 0.3rem 0.2rem 0;
  border-top: 1px solid #e9ecef;
}
.content-type-mini {
  margin-top: 0.5rem;
}
.content-type-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  border: 1px solid #dee2e6;
  font-size: 0.75rem;
  cursor: pointer;
  background: #fff;
  color: #495057;
  user-select: none;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.content-type-pill.active {
  background-color: #0096fe;
  border-color: #0096fe;
  color: #fff;
}
/* Intereses de audiencia — dropdown autocomplete */
.interest-input-wrapper {
  position: relative;
}
.interest-dropdown {
  position: absolute;
  z-index: 1050;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  overflow: hidden;
}
.interest-type-tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
}
.interest-type-tab {
  flex: 1;
  padding: 0.4rem 0.5rem;
  text-align: center;
  font-size: 0.8rem;
  cursor: pointer;
  color: #495057;
  user-select: none;
  transition: background 0.15s, color 0.15s;
}
.interest-type-tab:first-child { border-right: 1px solid #dee2e6; }
.interest-type-tab.active { background: #0096fe; color: #fff; font-weight: 600; }
.interest-type-tab:not(.active):hover { background: #f8f9fa; }
.interest-dropdown-list { max-height: 180px; overflow-y: auto; }
.interest-dropdown-item {
  padding: 0.35rem 0.75rem;
  font-size: 0.82rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #495057;
}
.interest-dropdown-item:hover { background: #f0f6ff; }
.interest-dropdown-item.is-selected { color: #0096fe; font-weight: 500; }
.interest-dropdown-hint {
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #6c757d;
  font-style: italic;
}
.interest-chip {
  display: inline-flex;
  align-items: center;
  background: #e8f4ff;
  color: #0060b0;
  border: 1px solid #b8d9f8;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 0.75rem;
  gap: 4px;
}
.interest-chip-x {
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
}
.interest-chip-x:hover { color: #d32f2f; }

.keyword-locked-display {
  flex: 1;
  min-width: 0;
  gap: 4px;
}
.keyword-locked-text {
  font-size: 0.875rem;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
.keyword-edit-btn,
.keyword-clear-btn {
  cursor: pointer;
  color: #6c757d;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  &:hover { color: #0096fe; }
}
.keyword-clear-btn:hover { color: #d32f2f; }
.yti-cat-active {
  color: #0096fe;
  font-weight: 600;
}
.mb-05 { margin-bottom: 0.3rem; }
.mt-05 { margin-top: 0.3rem; }
.my-05 { margin-top: 0.3rem; margin-bottom: 0.3rem; }
.ml-1 { margin-left: 0.25rem; }
.mr-03 { margin-right: 0.3rem; }
.icon-size-14 { font-size: 14px; }


#card-youtube-internal-filters > .card-body {
  padding: 8px 20px 8px 8px;
  display: flex;
  align-items: center;
  @media(max-width: 991px) {
    flex-wrap: wrap;
    padding: 8px;
  }
}
</style>
<style lang="scss">
.select-network-search {
  width: auto;
  @media(max-width: 991px) {
    width: 100% !important;
  }
}
/* Estilos de la barra de búsqueda YTI */
.yti-search-bar-wrap {
  .card-filters-search-by {
    background-color: transparent;
    margin: 0.7em 0;
    border-radius: 0.42rem;
    height: auto;
    @media(min-width: 769px) {
      height: 41.4px;
      box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
      margin: 0.7em 0 1.7em;
      background-color: white;
    }
  }
  .select-filters-searcher-by {
    height: 100%;
    border-right: 1px solid #E2E8F0;
    background-color: white;
    @media(max-width: 768px) {
      width: 100%;
      margin-bottom: 0.7em;
      border-radius: 0.42rem;
    }
  }
  .input-search-by-influencer {
    border: none;
    box-shadow: none;
    @media(max-width: 768px) {
      border-radius: 0.42rem;
      box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    }
  }
  .float-suggestions-search {
    width: 100%;
    height: auto;
    max-height: 400px;
    overflow-x: scroll;
    background-color: white;
    border-radius: 6px;
    padding: 1.5em;
    position: absolute;
    top: 3.5em;
    z-index: 100;
    box-shadow: 0 20px 45px #181a1c29, 0 -1px 6px #1d21260d;
    column-count: 1;
    column-fill: auto;
    .text-category:hover {
      background-color: #E2E8F0;
      transition: all 300ms;
      cursor: pointer;
      border-radius: 0.35em;
    }
    @media(min-width: 768px) {
      column-count: 3;
    }
  }
  #yti-mode-select,
  #yti-interest-type-select {
    .vs__dropdown-toggle {
      border: none;
      padding: 0;
      height: 100%;
      min-width: 140px;
    }
    .vs__search::placeholder,
    .vs__dropdown-toggle { background: transparent; }
    .vs__search { padding: 0; margin: 0; }
    .vs__selected-options { padding: 0 0.75rem; flex-wrap: nowrap; }
    .vs__selected { margin: 0; padding: 0; font-size: 0.875rem; color: #495057; }
    .vs__actions { padding-right: 0.5rem; }
  }
}
</style>
